import React from 'react';
import IconButton from '../../icon-button';
import withPopover from '../hoc/with-popover';

const UndoButton = (props) => <IconButton {...props} glyph="undo" />;

export default withPopover(UndoButton);
